import React from 'react';
import './style.css';

class service extends React.Component{
    render(){
        return(
            
            <div class="space">
                <div class="main">
                <h1>Terms of Service</h1>
                <p>Last updated: </p>
                <p>Please read these Terms of Service ("Terms", "Terms of Service") carefully before using  (the "Service") operated by  ("us", "we", or "our").</p>
                <p>Your access to and use of the Service is conditioned on your acceptance of and compliance with these Terms. These Terms apply to all visitors, users and others who access or use the Service.</p>
                <p>By accessing or using the Service you agree to be bound by these Terms. If you disagree with any part of the terms then you may not access the Service. </p>
                <p><strong>Contact Us</strong></p>
                <p>If you have any questions about these Terms, please contact us.</p>
        
        
              
                </div>
            </div>
            )
        }
    }
    export  default service